import React, { useState } from "react";
import { Box, IconButton, MobileStepper } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { IScratchpayRenewalPending } from "../../services/get-alerts/get-alerts.interface";
import ScratchPayRenewalPendingDashboardCard from "./ScratchPayRenewalPendingDashboardCard";

interface ICarouselScratchPayRenewalCardProps {
  renewalData: IScratchpayRenewalPending[];
}

const CarouselScratchPayRenewalCard = ({ renewalData }: ICarouselScratchPayRenewalCardProps) => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = renewalData.length;

  const handleNext = () => {
    setActiveStep((prevStep) => (prevStep + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => (prevStep - 1 + maxSteps) % maxSteps);
  };

  if (maxSteps === 1) {
    return <ScratchPayRenewalPendingDashboardCard renewalData={renewalData[0]} />;
  }

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      <ScratchPayRenewalPendingDashboardCard renewalData={renewalData[activeStep]} />

      <IconButton
        onClick={handleBack}
        sx={{
          "position": "absolute",
          "left": 0,
          "top": "50%",
          "transform": "translateY(-50%)",
          "bgcolor": "transparent",
          "minWidth": "32px",
          "padding": 0,
          "zIndex": 1,
          "&:hover": {
            bgcolor: "transparent",
            color: "primary.main",
          },
        }}
      >
        <ArrowBackIosIcon sx={{ fontSize: 16 }} />
      </IconButton>

      <IconButton
        onClick={handleNext}
        sx={{
          "position": "absolute",
          "right": 0,
          "top": "50%",
          "transform": "translateY(-50%)",
          "bgcolor": "transparent",
          "minWidth": "32px",
          "padding": 0,
          "zIndex": 1,
          "&:hover": {
            bgcolor: "transparent",
            color: "primary.main",
          },
        }}
      >
        <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
      </IconButton>

      <MobileStepper
        variant="dots"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={undefined}
        backButton={undefined}
        sx={{
          "position": "absolute",
          "bottom": 0,
          "left": "50%",
          "transform": "translateX(-50%)",
          "bgcolor": "transparent",
          "justifyContent": "center",
          "zIndex": 2,
          "width": "auto",
          "& .MuiMobileStepper-dot": {
            width: 5,
            height: 5,
          },
          "& .MuiMobileStepper-dotActive": {
            bgcolor: "warning.main",
          },
        }}
      />
    </Box>
  );
};

export default CarouselScratchPayRenewalCard;
